import React from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const DefectIssueSummary = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const locale = useLocaleContext();
  const {
    reportIssue: {
      form: {
        Max_200_Characters: max200Characters,
        labelIssueSummary,
        placeHolderIssueSummary
      }
    }
  } = locale === 'en-US' ? EN : FR;
  
  return (
    <div>
      <TextInput
        label={`${labelIssueSummary} *`}
        hint={max200Characters}
        value={fieldData.issueSummary || ''}
        placeholder={placeHolderIssueSummary}
        validation={'issueSummary' in formErrors ? 'error' : undefined}
        feedback={
          'issueSummary' in formErrors ? formErrors.issueSummary.message : ''
        }
        onChange={(value) => {
          if (!value)
            setFormErrors({
              ...formErrors,
              issueSummary: { message: 'Field is required' }
            });
          else if (value.length > 200)
            setFormErrors({
              ...formErrors,
              issueSummary: { message: 'Maximum 200 characters allowed' }
            });
          else {
            const errors = { ...formErrors };
            delete errors.issueSummary;
            setFormErrors({
              ...errors
            });
          }
          setFieldData(previousValue => ({
            ...previousValue,
            issueSummary: value
          }));
        }}
      />
    </div>
  );
};

DefectIssueSummary.propTypes = {
  formErrors: PropTypes.shape({
    issueSummary: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectIssueSummary;
